module.exports = __webpack_public_path__ + "static/img/1627_phase_function_Paper_PointsHejduk_Prediction.f66ac7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1627_phase_function_Paper_PointsHejduk_Prediction.png
// module id = pjXT
// module chunks = 0